import SearchIcon from "@mui/icons-material/Search";
import { Grid, MenuItem, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../../../../components/customSelect";
import TextInput from "../../../../components/TextInputs";
import { setProductCurrentPage } from "../../../../lib/slices/paginationSlice";
import { setSupplierProductCategoryId, setSupplierProductSearchValue, setSupplierProductSubCategoryId, setSupplierProductSubSubCategoryId } from "../../../../lib/slices/search_key_slice";
import { getEcommerceCategories, getEcommerceSubCategories, getEcommerceSubSubCategories } from "../../../../services/supplier/categoriesApiFn";

export const Filters = () => {
    // Translation Hook
    const { t } = useTranslation();
    // Redux Hook
    const dispatch = useDispatch();
    // Get Search Key from Redux
    const searchKey = useSelector((state) => state.SearchKeysReducer.searchKeys);
    // Get Current Language from Redux
    const { currentLanguage } = useSelector((state) => state.translationReducer);
    // Categories State
    const [allCategories, setAllCategories] = useState([]);
    // Sub Categories State
    const [allSubCategories, setAllSubCategories] = useState([]);
    // Sub Sub Categories State
    const [allSubSubCategories, setAllSubSubCategories] = useState([]);

    // Fetch Ecommerce Categories
    const fetchEcommerceCategories = async () => {
        try {
            const response = await getEcommerceCategories();
            if (response?.data?.status === "success") {
                setAllCategories(response?.data?.data);
            } else {
                console.error(response?.data?.message);
            }
        } catch (error) {
            console.error(error);
        }
    };

    // Fetch Ecommerce Sub Categories
    const fetchEcommerceSubCategories = async (value) => {
        try {
            const params = {
                categoryId: value,
            }
            const response = await getEcommerceSubCategories(params);
            if (response?.data?.status === "success") {
                setAllSubCategories(response?.data?.data);
            } else {
                console.error(response?.data?.message);
            }
        } catch (error) {
            console.error(error);
        }
    };

    // Fetch Ecommerce Sub Sub Categories
    const fetchEcommerceSubSubCategories = async (value1, value2) => {
        try {
            const params = {
                categoryId: value1,
                subCategoryId: value2,
            }
            const response = await getEcommerceSubSubCategories(params);
            if (response?.data?.status === "success") {
                setAllSubSubCategories(response?.data?.data);
            } else {
                console.error(response?.data?.message);
            }
        } catch (error) {
            console.error(error);
        }
    };

    // Fetch Categories, Sub Categories and Sub Sub Categories
    useEffect(() => {
        fetchEcommerceCategories();
        fetchEcommerceSubCategories("All");
        fetchEcommerceSubSubCategories("All", "All");
    }, []);




    return (
        <Stack p={2} bgcolor={"primary.light"}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextInput
                        placeholder={t("supplierProductTab.searchProduct")}
                        variant="outlined"
                        value={searchKey.supplierProductSearchValue}
                        onChange={(e) => {
                            dispatch(setSupplierProductSearchValue(e.target.value));
                        }}
                        InputStartIcon={<SearchIcon />}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <CustomSelect
                        placeholder={t("common.category")}
                        value={searchKey.supplierProductCategoryId}
                        onChange={(e) => {
                            dispatch(setProductCurrentPage(1));
                            dispatch(setSupplierProductCategoryId(e.target.value));
                            fetchEcommerceSubCategories(e.target.value);
                            fetchEcommerceSubSubCategories(e.target.value, "All");

                            dispatch(setSupplierProductSubCategoryId("All"));
                            dispatch(setSupplierProductSubSubCategoryId("All"));
                        }}

                    >
                        <MenuItem value={"All"}>{t("common.all")}</MenuItem>
                        {allCategories.map((val, ind) => {
                            return (
                                <MenuItem
                                    key={ind}
                                    value={val._id}
                                    sx={{ textTransform: "capitalize" }}
                                >
                                    {val.name[currentLanguage]}
                                </MenuItem>
                            );
                        })}
                    </CustomSelect>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <CustomSelect
                        placeholder={t("common.subCategory")}
                        value={searchKey.supplierProductSubCategoryId}
                        onChange={(e) => {
                            dispatch(setProductCurrentPage(1));
                            dispatch(setSupplierProductSubCategoryId(e.target.value));
                            fetchEcommerceSubSubCategories(searchKey.supplierProductCategoryId, e.target.value);
                            dispatch(setSupplierProductSubSubCategoryId("All"));
                        }}

                    >
                        <MenuItem value={"All"}>{t("common.all")}</MenuItem>
                        {allSubCategories.map((val, ind) => {
                            return (
                                <MenuItem
                                    key={ind}
                                    value={val._id}
                                    sx={{ textTransform: "capitalize" }}
                                >
                                    {val.name[currentLanguage]}
                                </MenuItem>
                            );
                        })}
                    </CustomSelect>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <CustomSelect
                        placeholder={t("common.subSubCategory")}
                        value={searchKey.supplierProductSubSubCategoryId}
                        onChange={(e) => {
                            dispatch(setProductCurrentPage(1));
                            dispatch(setSupplierProductSubSubCategoryId(e.target.value));
                        }}

                    >
                        <MenuItem value={"All"}>{t("common.all")}</MenuItem>
                        {allSubSubCategories.map((val, ind) => {
                            return (
                                <MenuItem
                                    key={ind}
                                    value={val._id}
                                    sx={{ textTransform: "capitalize" }}
                                >
                                    {val.name[currentLanguage]}
                                </MenuItem>
                            );
                        })}
                    </CustomSelect>
                </Grid>
            </Grid>
        </Stack>
    )
}